import type { FhhState } from '../fhhDefaultState';

export const useFhhValidation = (state: Partial<FhhState>, pristine: boolean) => {
    const validateState = (): boolean => true;

    const invalid = {
        startDate: !pristine && !!state.endDate && !state.startDate,
        endDate: !pristine && !!state.startDate && !state.endDate,
    };

    return { validateState, invalid };
};
